import ReactDOM from 'react-dom';
import React, { useState } from 'react';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

interface Link {
  title: string;
  url: string;
}

const BreederLinks = (props: any) => {
  const { links } = props;
  const parsedLinks: Link[] = JSON.parse(links);
  const [showAll, setShowAll] = useState(false);
  const { width } = useWindowDimensions();

  const totalItems = parsedLinks.length;
  const initialItemsToShow = width < 768 ? 4 : 16;
  const itemsToShow = showAll ? totalItems : initialItemsToShow;

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <section className="py-5 bg-blue-100">
      <div className="breeder-links-container">
        <div className="row">
          {parsedLinks.map((link, index) => (
            <div
              key={link.title}
              className={`breeder-link-container col-md-3 mb-3 justify-content-center align-items-center text-center ${index < itemsToShow ? 'd-flex' : 'd-none'}`}
            >
              <a href={link.url} className="text-decoration-none breed-link">
                {link.title}
              </a>
            </div>
          ))}
        </div>
        {totalItems > initialItemsToShow && (
          <div className="d-flex justify-content-center mt-4">
            <a className="text-primary cursor-pointer" onClick={toggleShowAll} onKeyPress={toggleShowAll}>
              {showAll ? 'Show Less' : 'Show More'}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

const element = document.getElementById('react-breeder-links');
if (element) {
  const links = element.getAttribute('data-links') ?? '[]';
  ReactDOM.render(<BreederLinks links={links} />, element);
}
